import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from '../../config';
import { headers } from "../../token";
import UpdateObject from "./UpdateObject";
import DeleteObject from "./DeleteObject";

const server_backend = config.API_URL;

const Objects = ({ username }) => {
    const [ObjectList, setObjectList] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [onObjectID, setOnObjectID] = useState(0);
    const [filtersEnabled, setFiltersEnabled] = useState(false);
    const [filterBy, setFilterBy] = useState("name");
    const [filterStatus, setFilterStatus] = useState(0);
    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        getObjects();
    }, []);

    const getObjects = async () => {
        try {
            const response = await axios.get(`${server_backend}/Objects/list`, headers);
            console.log("Unexpected error, please check")
            if (response.data.RES_CODE === "00") {
                setObjectList(response.data.RES_RESULT);
            }
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    };

    const CloseModal = () => {
        setIsUpdating(false);
    };

    const handleFiltersToggle = () => {
        setFiltersEnabled(!filtersEnabled);
    };

    const handleFilterByChange = (e) => {
        setFilterBy(e.target.value);
    };

    const handleFilterStatusChange = (e) => {
        setFilterStatus(e.target.value);
    };

    const handleFilterValueChange = (e) => {
        setFilterValue(e.target.value);
    };

    const FilterObject = async () => {
        try {
            const response = await axios.get(`${server_backend}/objects/search?user_transaction=${username}&findby=${filterBy}&findfor=${filterValue}&est_id=${filterStatus}`, headers);
            setObjectList(response.data.RES_RESULT);
        } catch (error) {
            console.log("Unexpected error, please check")
        }
    };

    useEffect(() => {
        if (filtersEnabled) {
            FilterObject();
        } else {
            getObjects(); // Reset to the full object list if filters are disabled
        }
    }, [filterBy, filterStatus, filterValue, filtersEnabled]);

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">Objects List</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="javascript: void(0);">Objects</a></li>
                                    <li className="breadcrumb-item active">Objects List</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="tasksList">
                            <div className="card-header border-0">
                                <div className="d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">All Objects</h5>
                                    <div className="col-xxl-1 col-sm-2" style={{ paddingRight: "2px" }}>
                                        <button type="button" className="btn btn-primary w-100" onClick={handleFiltersToggle}>
                                            <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                                        </button>
                                    </div>

                                </div>
                            </div>
                            {filtersEnabled && (
                                <div className="card-body border border-dashed border-end-0 border-start-0">
                                    <form>
                                        <div className="row g-3">
                                            <div className="col-6">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterByChange}
                                                    >
                                                        <option>Filter by</option>
                                                        <option value="name">Name</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="input-light">
                                                    <select
                                                        className="form-control custom-select-style"
                                                        disabled={!filtersEnabled}
                                                        onChange={handleFilterStatusChange}
                                                    >
                                                        <option value={0}>Filter status</option>
                                                        <option value={1}>ACTIVATED</option>
                                                        <option value={2}>DISABLED</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div className="search-box">
                                                    <input
                                                        type="text"
                                                        className="form-control search bg-light border-light"
                                                        placeholder="Search for tasks or something..."
                                                        onChange={handleFilterValueChange}
                                                    />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            )}
                            <div className="card-body">
                            <div
  className="table-responsive table-card mb-4"
  style={{ minHeight: "60vh", display: "flex", flexDirection: "column" }}
>
                            <table className="table align-middle table-nowrap mb-0" id="tasksTable">
                                        <thead className="table-light text-muted">
                                            <tr>

                                                <th scope="col">ID</th>
                                                <th className="th-hover">Name</th>
                                                <th>Status</th>

                                            </tr>
                                        </thead>
                                        <tbody className="list form-check-all">
                                            {ObjectList.map((Objects_L) => (
                                                <tr key={Objects_L.obj_ID}>
                                                    <th scope="row">
                                                        <div className="form-check">{Objects_L.obj_ID}</div>
                                                    </th>
                                                    <td className="client_name">{Objects_L.name}</td>
                                                    <td className="status">
                                                        <span className={`${Objects_L.status_name === 'ACTIVATED' ? "badge badge-soft-success" : "badge badge-soft-danger"} text-uppercase`}>
                                                            {Objects_L.status_name}
                                                        </span>
                                                    </td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {isUpdating && (
                    <UpdateObject username={username} onObjectID={onObjectID} onClose={CloseModal} getObjects={getObjects} />
                )}
            </div>
        </div>
    );
};

export default Objects;
